import { useEffect } from "react"
import { useProfileStore } from "./profileStore"
import { useShallow } from "zustand/react/shallow"
import { useLanguageStore } from "./languageStore"

export const LanguageInitializer = ({ children }) => {
    const { storageKey, language, defaultLanguage, setLanguage } =
        useLanguageStore(
            useShallow((state) => ({
                storageKey: state.storageKey,
                language: state.language,
                defaultLanguage: state.defaultLanguage,
                setLanguage: state.setLanguage,
            })),
        )
    const hasAllowedCookies = useProfileStore(
        (state) => state.hasAllowedCookies,
    )

    useEffect(() => {
        if (hasAllowedCookies) {
            localStorage.setItem(storageKey, language)
        }
    }, [hasAllowedCookies, storageKey])

    useEffect(() => {
        if (!hasAllowedCookies) {
            localStorage.removeItem(storageKey)
            setLanguage(defaultLanguage)
        }
    }, [storageKey])

    return <>{children}</>
}
